import app from '../../common/app';
import app2 from '../../forum/app';
import Component from '../Component';
import Button from './Button';
import LinkButton from './LinkButton';
import type Mithril from 'mithril';
import classList from '../utils/classList';
import UserPage from '../../forum/components/UserPage';
import ChatRoom from '../../forum/components/ChatRoom';
/**
 * The `Navigation` component displays a set of navigation buttons. Typically
 * this is just a back button which pops the app's History. If the user is on
 * the root page and there is no history to pop, then in some instances it may
 * show a button that toggles the app's drawer.
 *
 * If the app has a pane, it will also include a 'pin' button which toggles the
 * pinned state of the pane.
 *
 * Accepts the following attrs:
 *
 * - `className` The name of a class to set on the root element.
 * - `drawer` Whether or not to show a button to toggle the app's drawer if
 *   there is no more history to pop.
 */
export default class Navigation extends Component {
  oninit(vnode: any) {
    super.oninit(vnode);
    // if (app.session.user) {
    //    // 查询平台币余额
    //   app.request({
    //     method: 'GET',
    //     url: app.forum.attribute('apiUrl') + '/sdkUserPc',
    //   }).then(res=>{
    //     this.balance = res.balance;
    //     m.redraw()
    //   })
    // }

    // if (app.session.user) {

    // }
  }

  view() {
    const { history, pane } = app;

    return (
      <div
        className={classList('Navigation ButtonGroup', this.attrs.className)}
        onmouseenter={pane && pane.show.bind(pane)}
        onmouseleave={pane && pane.onmouseleave.bind(pane)}
      >
        {history?.canGoBack() ? [this.getBackButton()] : this.getDrawerButton()}
      </div>
    );
  }

  /**
   * Get the back button.
   */
  protected getBackButton(): Mithril.Children {
    const { history } = app;
    const previous = history?.getPrevious();

    return (
      <LinkButton
        className="Button Navigation-back Button--icon"
        href={history?.backUrl()}
        icon="fas fa-chevron-left"
        aria-label={previous?.title}
        onclick={(e: MouseEvent) => {
          e.stopPropagation();
          if (e.shiftKey || e.ctrlKey || e.metaKey || e.which === 2) return;
          e.preventDefault();
          if (
            app2.current.matches(UserPage) &&
            (previous?.name === 'user.collections' || previous?.name === 'user.posts')
          ) {
            history?.back();
            history?.back();
          } else {
            history?.back();
          }
        }}
      />
    );
  }

  /**
   * Get the pane pinned toggle button.
   */
  protected getPaneButton(): Mithril.Children {
    const { pane } = app;

    if (!pane || !pane.active) return null;

    return (
      <Button
        className={classList('Button Button--icon Navigation-pin', { active: pane.pinned })}
        aria-label="navigation"
        onclick={pane.togglePinned.bind(pane)}
        icon="fas fa-thumbtack"
      />
    );
  }

  /**
   * Get the drawer toggle button.
   */
  protected getDrawerButton(): Mithril.Children {
    if (!this.attrs.drawer) return null;
    const unread = this.getUnreadCount();

    const { drawer } = app;
    const user = app.session.user;

    return (
      <Button
        className={classList('Button Button--icon Navigation-drawer', { new: user?.newNotificationCount() })}
        onclick={(e: MouseEvent) => {
          e.stopPropagation();
          drawer.show();
        }}
        // icon="fas fa-bars"
        aria-label={app.translator.trans('core.lib.nav.drawer_button')}
      >
        {unread && unread > 0 ? <span className="NotificationsDropdown-unread"></span> : null}
      </Button>
    );
  }
  getUnreadCount() {
    if (!app.session || !app.session.user) return;
    const currentOpenimChat = (app.data as any).currentOpenimChat as any;
    const chatRoom1Id = (currentOpenimChat && currentOpenimChat.chatRoomGroupId) || '';
    const unreadData = ChatRoom.getUnreadCount(chatRoom1Id, 1);
    const isUnread = unreadData && unreadData.isUnread !== 0 ? 1 : 0;
    const flagsCache = (app as any)?.flags?.cache;
    if (app.session.user.isAdmin() && flagsCache && flagsCache.length > 0) {
      return flagsCache.length || isUnread;
    }
    return app.session.user!.unreadNotificationCount() || isUnread;
  }
}
